import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';

import SearchableDataTable from '../../../shared/components/SearchableDataTable';

import { 
  alphabeticallySort,
  textContains,
  formatPaymentMethod
} from '../../../shared/utils';

class AccountBillingList extends Component {
  render(){
    const {paymentMethods,defaultPaymentMethodId} = this.props;

    return (
      <div>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={paymentMethods}
              searchPromptText='Search by name or last 4 digits'
              emptyText='This account has no payment methods linked to it'
              columns={[
                {
                  display:'Billing Method',
                  name:'name',
                  width:70,
                  filterFunc:(a,searchParam) => textContains(formatPaymentMethod(a),searchParam),
                  sortFunc:(a,b) => alphabeticallySort(formatPaymentMethod(a),formatPaymentMethod(b)),
                  renderCell:(item) => formatPaymentMethod(item)
                },
                {
                  display:'Default',
                  name:'defaultPaymentMethodId',
                  width:30,
                  sortFunc:(a,b) => (b.id === defaultPaymentMethodId) - (a.id === defaultPaymentMethodId),
                  renderCell:(item) => (
                    <input 
                      type='radio'
                      name='defaultPaymentMethodId'
                      value={item.id} 
                      defaultChecked={item.id === this.props.defaultPaymentMethodId}
                      disabled={item.id !== this.props.defaultPaymentMethodId}
                    />                    
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountBillingList;



// WEBPACK FOOTER //
// ./src/routes/AccountBillingList/components/AccountBillingList.js